/**
 * Morse code — pure, deterministic text ↔ Morse translation.
 * Safe to render server-side.
 */

export const MORSE: Record<string, string> = {
  A: ".-",
  B: "-...",
  C: "-.-.",
  D: "-..",
  E: ".",
  F: "..-.",
  G: "--.",
  H: "....",
  I: "..",
  J: ".---",
  K: "-.-",
  L: ".-..",
  M: "--",
  N: "-.",
  O: "---",
  P: ".--.",
  Q: "--.-",
  R: ".-.",
  S: "...",
  T: "-",
  U: "..-",
  V: "...-",
  W: ".--",
  X: "-..-",
  Y: "-.--",
  Z: "--..",
  "0": "-----",
  "1": ".----",
  "2": "..---",
  "3": "...--",
  "4": "....-",
  "5": ".....",
  "6": "-....",
  "7": "--...",
  "8": "---..",
  "9": "----.",
  ".": ".-.-.-",
  ",": "--..--",
  "?": "..--..",
  "'": ".----.",
  "!": "-.-.--",
  "/": "-..-.",
  "(": "-.--.",
  ")": "-.--.-",
  "&": ".-...",
  ":": "---...",
  ";": "-.-.-.",
  "=": "-...-",
  "+": ".-.-.",
  "-": "-....-",
  _: "..--.-",
  '"': ".-..-.",
  $: "...-..-",
  "@": ".--.-.",
};

const REVERSE: Record<string, string> = Object.fromEntries(
  Object.entries(MORSE).map(([k, v]) => [v, k]),
);

/** Encode text to Morse: letters separated by spaces, words by " / ". */
export function textToMorse(text: string): string {
  return text
    .trim()
    .split(/\s+/)
    .filter((w) => w.length > 0)
    .map((word) =>
      [...word.toUpperCase()]
        .map((ch) => (Object.hasOwn(MORSE, ch) ? MORSE[ch] : ""))
        .filter((code) => code !== "")
        .join(" "),
    )
    .filter((w) => w.length > 0)
    .join(" / ");
}

/** Decode Morse back to text. Unknown tokens become "?". */
export function morseToText(morse: string): string {
  return morse
    .trim()
    .split("/")
    .map((word) =>
      word
        .trim()
        .split(/\s+/)
        .filter((t) => t.length > 0)
        .map((tok) => (Object.hasOwn(REVERSE, tok) ? REVERSE[tok] : "?"))
        .join(""),
    )
    .filter((w) => w.length > 0)
    .join(" ");
}
